/* ==========================================================================
   SearcherFerryHotel > Client > Vehicle
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const InputPanelClient = require('../../../../input-panel/client/js');
const InputPanelActions = require('../../../../input-panel/client/js/store/actions');

const PanelVehicleTemplate = require('../../../templates/vehicle');
const { initVehicles, destroyVehicles, updateVehicles } = require('./panel');

const { types } = require('../store/actions');
const configuration = require('../config');

function setVehicleInfo(instance) {
    if (!instance.vehicleInput) return;
    const { config = {} } = instance;
    const { literals = {} } = config;
    const { trailerInfo = '', units } = literals;

    /* Data */
    const { vehicle = {}, vehicleLength, vehicleHeight, trailer } = instance.store.select('data');
    const { label = '' } = vehicle;

    const vehicleMeasures = vehicleLength ? `, ${vehicleLength}${units} x ${vehicleHeight}${units}` : '';
    const trailerText = trailer ? ` + ${trailerInfo}` : '';

    const value = ''.concat(label, vehicleMeasures, trailerText);

    instance.vehicleInput.actions.changeValue(value);
}

function renderPanelVehicle(instance) {
    const { config = {}, store = {} } = instance;
    const { context = {}, literals = {}, select } = config;

    /* Data store */
    const { vehicle, vehicles = [] } = store.select('data');

    const { value } = vehicle;
    const options = vehicles.map(option => ({
        ...option,
        selected: option.value === value
    }));

    const dataPanelVehicle = addData(
        {
            config: {
                ...select
            },
            literals,
            vehicles: options
        },
        { type: configuration().type.vehicle }
    );

    return PanelVehicleTemplate(dataPanelVehicle, context);
}

/* Add vehicle */
function addPanelVehicle(instance) {
    const result = instance;
    const { vehicleInput } = instance;
    const contentTemplate = html(
        `<div class='input-panel__body' ${configuration().hooks.panelBody}>${renderPanelVehicle(instance)}</div>`
    );

    /* add accomodation to panel */
    vehicleInput.actions.setContent(contentTemplate);

    result.hooks = {
        ...result.hooks,
        panelBody: vehicleInput.element.querySelector(`[${configuration().hooks.panelBody}]`)
    };

    /* Init */
    initVehicles(instance);
}

function initVehicle(instance) {
    const result = instance;
    const { config = {}, selector } = instance;
    const { vehicle: vehicleConfig } = config;

    result.vehicleInput = InputPanelClient(
        `${selector} [data-component="InputPanel"][data-type="${configuration().type.vehicle}"]`
    );

    if (result.vehicleInput) {
        /* Extend reactions */
        result.reactions = {
            ...result.reactions,
            changeVehicle: result.store.subscribe((state, action) => {
                if (action.type !== types.CHANGE_VEHICLE) return;

                /* Ui update panel content */
                if (action.payload.vehicle) updateVehicles(result);

                /* Sync panel -> input */
                setVehicleInfo(result);
            }),
            setVehicle: result.store.subscribe((state, action) => {
                if (action.type !== types.SET_VEHICLE) return;

                /* Sync panel -> input */
                setVehicleInfo(result);
            }),
            destroyVehicleInput: result.vehicleInput.store.subscribe((state, action) => {
                if (action.type !== InputPanelActions.types.DESTROY) return;

                destroyVehicles(result);
                delete result.vehicleInput;
            }),
            openVehicles: result.vehicleInput.store.subscribe((state, action) => {
                if (action.type !== InputPanelActions.types.OPEN_PANEL) return;

                addPanelVehicle(result);
                result.actions.openPanel('vehicleInput');
            }),
            closeVehicle: result.vehicleInput.store.subscribe((state, action) => {
                if (action.type !== InputPanelActions.types.CLOSE_PANEL) return;

                /* Destroy */
                destroyVehicles(instance);
                result.actions.closePanel('vehicleInput');
            })
        };

        /* Sync store */
        if (vehicleConfig) {
            const { items = [], trailerHeight, trailerLength, trailer } = vehicleConfig;
            const vehicleSelected = items.filter(item => item.selected)[0] || vehicleConfig.items[0];

            const { height: vehicleHeight, length: vehicleLength } = vehicleSelected;

            instance.actions.setVehicle({
                vehicles: items,
                vehicle: vehicleSelected,
                vehicleHeight,
                vehicleLength,
                trailer,
                trailerHeight,
                trailerLength
            });
        }
    }
}

/* Exports */
module.exports = {
    initVehicle,
    addPanelVehicle
};
